/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {useAuthenticatedUser} from '../pages/admin/users/useAuthenticatedUser';
import {systemOfUnitsSelector} from '../store/selectors/login';

/**
 * useSystemOfUnits returns systemOfUnits stored in user profile state
 *
 */
export const useSystemOfUnits = () => {
  const state = useSelector(systemOfUnitsSelector);
  return useAuthenticatedUser()?.systemOfUnits?.value || state || null;
};
